import PropTypes from "prop-types"
import React from "react"

const ChatThreadEmptyState = ({ title, description, icon = "fa-envelope" }) => {
  return (
    <div className="flex justify-center p-8">
      <div className="flex max-w-xl flex-col items-center justify-center">
        {icon && (
          <i
            data-testid="empty-state-icon"
            className={`fa-solid ${icon} text-5xl leading-none text-blue-700`}
          />
        )}
        <div className="mt-2 text-center text-lg font-semibold text-gray-900">
          {title}
        </div>
        {description && (
          <p className="mb-0 mt-1 text-center text-gray-600">{description}</p>
        )}
      </div>
    </div>
  )
}

ChatThreadEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string,
}

export default ChatThreadEmptyState
